module.exports = __webpack_public_path__ + "img/cod_k.08a4801b.png";